import React, {ReactNode} from "react";
import {twMerge} from "tailwind-merge";

type Props = {
    className?: string,
    center?: boolean,
    children: ReactNode,
};

const SlimContainer = ({className, center = true, children}: Props) => {
    return (
        <div
            className={twMerge(
                "w-full max-w-[1000px]",
                center ? "mx-auto" : "",
                className,
            )}
        >
            {children}
        </div>
    );
};

export default SlimContainer;